import { Grid } from 'src/design/atoms/Grid';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { Checkbox } from 'src/design/atoms/Checkbox';
import { TextInput } from 'src/design/atoms/TextInput';
import React from 'react';
import { OfficeSelector } from 'src/app/selectors/OfficeSelectorSingle';
import { DatePicker } from 'src/design/atoms/DatePicker';

interface BaseTemplateDetailsProps {
  titleValue: string;
  onTitleValueChange: (value: string) => void;
  dateValue: Date;
  onDateValueChange: (value: Date) => void;
  activeValue: boolean;
  onActiveValueChange: (value: boolean) => void;
  officeValue: number;
  onOfficeValueChange: (value: number) => void;
  onSaveClick: () => void;
  templateId: string | null;
  isSaving: boolean;
  canSave: boolean;
}

export const BaseTemplateDetails: React.FC<BaseTemplateDetailsProps> = ({
  dateValue,
  onDateValueChange,
  activeValue,
  onActiveValueChange,
  officeValue,
  onOfficeValueChange,
  titleValue,
  onTitleValueChange,
  onSaveClick,
  isSaving,
  canSave,
  templateId,
}) => {
  return (
    <Grid>
      <Grid.Col span={3}>
        <Stack gap="xs">
          <Text fw={700}>Title</Text>
          <TextInput
            value={titleValue}
            onChange={(e) => {
              onTitleValueChange(e.currentTarget.value);
            }}
            placeholder="Template Title"
          />
        </Stack>
      </Grid.Col>
      <Grid.Col span={3}>
        <Stack gap="xs">
          <Text fw={700}>Office</Text>
          <OfficeSelector
            initialValue={''}
            initialOfficeId={officeValue}
            onOfficeChange={(office) => onOfficeValueChange(office?.id || -1)}
            onChange={console.log}
          />
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <Stack gap="xs">
          <Text fw={700}>As Of</Text>
          <DatePicker
            value={dateValue}
            onChange={(value) => {
              onDateValueChange(value as Date);
            }}
          />
        </Stack>
      </Grid.Col>
      <Grid.Col span={4}>
        <Grid className="m-t-23">
          <Grid.Col span={6}>
            <Checkbox
              label="Active"
              checked={activeValue}
              onChange={(e) => onActiveValueChange(e.currentTarget.checked)}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <BasicButton
              disabled={!canSave}
              loading={isSaving}
              onClick={onSaveClick}
            >
              {templateId ? 'Save' : 'Create'}
            </BasicButton>
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </Grid>
  );
};
